import { Flex, Result } from "antd";
import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    console.log(error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Flex justify="center" align="center" style={{ height: "100%" }}>
          <Result
            status="500"
            title="500"
            subTitle="Sorry, something went wrong."
          />
        </Flex>
      );
    }

    return this.props.children;
  }
}
